import React, { useState } from 'react';
import FilterCtx from './filterCtx';

const FilterContext = (props) => {
  const [docName, setDocName] = useState<string>('');
  const [typePickerBoard, setTypePickerBoard] = useState<boolean>(false);
  const [typePickerDocument, setTypePickerDocument] = useState<boolean>(false);
  const [docNameActivity, setDocNameActivity] = useState<string>('');
  const [publishChecked, setPublishChecked] = useState<boolean>(false);
  const [effectiveChecked, setEffectiveChecked] = useState<boolean>(false);
  const [asOfDate, setAsOfDate] = useState<string>('');
  const [period, setPeriod] = useState<string>('');
  const [classifications, setClassifications] = useState<any[]>([]);
  const [classificationsActivity, setClassificationsActivity] = useState<any[]>([]);
  const [investors, setInvestors] = useState<any[]>([]);
  const [investorsActivity, setInvestorsActivity] = useState<any[]>([]);
  const [funds, setFunds] = useState<any[]>([]);
  const [fundsActivity, setFundsActivity] = useState<any[]>([]);
  const [read, setRead] = useState<string>('');
  const [fromDate, setFromDate] = useState<string>('');
  const [toDate, setToDate] = useState<string>('');
  const [activityFeedFromDate, setActivityFeedFromDate] = useState<number>(30);
  const [classificationToggle, setClassificationToggle] = useState<boolean>(false);
  const [fundsToggle, setFundsToggle] = useState<boolean>(false);
  const [investorsToggle, setInvestorsToggle] = useState<boolean>(false);
  const [periodToggle, setPeriodToggle] = useState<boolean>(false);
  const [slicerChoices, setSlicerChoices] = useState<any[]>([]);
  const [initialGroup, setInitialGroup] = useState<any>([]);
  const [gridWidgetFilterState, setGridWidgetFilterState] = useState({});

  const clearFilters = () => {
    setDocName('');
    setPublishChecked(false);
    setEffectiveChecked(false);
    setClassifications([]);
    setInvestors([]);
    setFunds([]);
    setRead('');
    setFromDate('');
    setToDate('');
    setPeriod('');
    setClassificationToggle(false);
    setInvestorsToggle(false);
    setFundsToggle(false);
    setPeriodToggle(false);
    setSlicerChoices([]);
    setInitialGroup([]);
  };

  const clearSlices = () => {
    setClassificationToggle(false);
    setInvestorsToggle(false);
    setFundsToggle(false);
    setPeriodToggle(false);
    setSlicerChoices([]);
    setInitialGroup([]);
  };

  const clearAllFilters = () => {
    clearFiltersActivity();
    clearFilters();
  };

  const clearFiltersActivity = () => {
    setDocNameActivity('');
    setTypePickerBoard(false);
    setTypePickerDocument(false);
    setClassificationsActivity([]);
    setInvestorsActivity([]);
    setFundsActivity([]);
    setActivityFeedFromDate(30);
  };

  const hasFilters = () => {
    return !!(
      docName !== '' ||
      funds.length !== 0 ||
      investors.length !== 0 ||
      classifications.length !== 0 ||
      fromDate ||
      toDate ||
      period ||
      read === 'read' ||
      read === 'unread' ||
      classificationToggle ||
      investorsToggle ||
      fundsToggle ||
      periodToggle
    );
  };

  const hasActivityFilters = () => {
    return !!(
      docNameActivity !== '' ||
      typePickerBoard ||
      typePickerDocument ||
      fundsActivity.length !== 0 ||
      investorsActivity.length !== 0 ||
      classificationsActivity.length !== 0 ||
      activityFeedFromDate !== 30
    );
  };


  return (
    <FilterCtx.Provider
      value={{
        docName: docName,
        docNameActivity: docNameActivity,
        funds: funds,
        typePickerBoard: typePickerBoard,
        typePickerDocument: typePickerDocument,
        fundsActivity: fundsActivity,
        investors: investors,
        investorsActivity: investorsActivity,
        classifications: classifications,
        classificationsActivity: classificationsActivity,
        read: read,
        publishChecked: publishChecked,
        effectiveChecked: effectiveChecked,
        asOfDate: asOfDate,
        period: period,
        classificationToggle: classificationToggle,
        fundsToggle: fundsToggle,
        investorsToggle: investorsToggle,
        periodToggle: periodToggle,
        slicerChoices: slicerChoices,
        initialGroup: initialGroup,
        activityFeedFromDate: activityFeedFromDate,
        setDocName: setDocName,
        setTypePickerBoard: setTypePickerBoard,
        setTypePickerDocument: setTypePickerDocument,
        setDocNameActivity: setDocNameActivity,
        setFunds: setFunds,
        setFundsActivity: setFundsActivity,
        setInvestors: setInvestors,
        setInvestorsActivity: setInvestorsActivity,
        setClassifications: setClassifications,
        setClassificationsActivity: setClassificationsActivity,
        setRead: setRead,
        setPublishChecked: setPublishChecked,
        setEffectiveChecked: setEffectiveChecked,
        setAsOfDate: setAsOfDate,
        setPeriod: setPeriod,
        clearFilters: clearFilters,
        clearSlices: clearSlices,
        clearFiltersActivity: clearFiltersActivity,
        hasFilters: hasFilters,
        hasActivityFilters: hasActivityFilters,
        setClassificationToggle: setClassificationToggle,
        setFundsToggle: setFundsToggle,
        setInvestorsToggle: setInvestorsToggle,
        setPeriodToggle: setPeriodToggle,
        setSlicerChoices: setSlicerChoices,
        setInitialGroup: setInitialGroup,
        setActivityFeedFromDate: setActivityFeedFromDate,
        fromDate: fromDate,
        setFromDate: setFromDate,
        toDate: toDate,
        setToDate: setToDate,
        clearAllFilters: clearAllFilters,
        gridWidgetFilterState: gridWidgetFilterState,
        setGridWidgetFilterState: setGridWidgetFilterState,
      }}>
      {props.children}
    </FilterCtx.Provider>
  );
};

export default FilterContext;
